var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMobile
    ? _c(
        "div",
        { staticClass: "w-100 d-flex justify-content-center" },
        [
          _vm.isHsl()
            ? _c("video-player", {
                ref: "videoPlayer",
                attrs: { options: _vm.playerOptions },
                on: { ready: _vm.onPlayerReadied, timeupdate: _vm.onTimeupdate }
              })
            : _c(
                "video",
                {
                  staticClass: "video-player",
                  attrs: {
                    autoplay: "",
                    loop: "",
                    muted: "",
                    poster: "/imgext/bg-home-video.jpg",
                    id: "bgvid"
                  },
                  domProps: { muted: true }
                },
                [_c("source", { attrs: { src: _vm.video, type: _vm.type } })]
              )
        ],
        1
      )
    : _c("div", {
        staticClass: "position-absolute image-cover w-100 image-cover",
        style:
          "background-image: url(/imgext/bg-home-mobile.jpg); height: " +
          (_vm.windowHeight - 30) +
          "px;"
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60243d0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60243d0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/home/HomeVideo.vue
// module id = null
// module chunks = 